module.exports = __webpack_public_path__ + "img/1595321934.dd0db7cf.jpg";